import type { FrontendModule } from '@aurora/module-sdk/web';

/**
 * Frontend-Modul-Loader.
 *
 * Jedes Fachmodul registriert hier seinen Lazy-Import — das ist die EINZIGE
 * Stelle, an der die Shell Modulnamen kennt. Der dynamic import sorgt für
 * einen eigenen Chunk pro Modul; geladen wird er ausschließlich, wenn das
 * Modul für den aktiven Mandanten aktiviert ist.
 */
export const moduleLoaders: Record<string, () => Promise<{ default: FrontendModule }>> = {
  calendar: () => import('@aurora-modules/calendar/web'),
  crm: () => import('@aurora-modules/crm/web'),
  accounting: () => import('@aurora-modules/accounting/web'),
  catalog: () => import('@aurora-modules/catalog/web'),
  inventory: () => import('@aurora-modules/inventory/web'),
  sales: () => import('@aurora-modules/sales/web'),
  projects: () => import('@aurora-modules/projects/web'),
  hr: () => import('@aurora-modules/hr/web'),
};

export async function loadFrontendModules(enabledNames: string[]): Promise<FrontendModule[]> {
  const loadable = enabledNames.filter((name) => name in moduleLoaders);
  const loaded = await Promise.all(
    loadable.map(async (name) => {
      const moduleExport = await moduleLoaders[name]!();
      const frontendModule = moduleExport.default;
      if (frontendModule.name !== name) {
        throw new Error(
          `Frontend-Modul "${frontendModule.name}" passt nicht zum Backend-Modul "${name}".`,
        );
      }
      return frontendModule;
    }),
  );
  return loaded;
}
